import React from "react";
import { notify } from "../../../Notify/Notify";

function ExcelUploadButton({
  onChange = () => console.log("No onChange is provided to ExcelUploadButton"),
}) {
  const inputRef = React.useRef(null);

  const handleClick = () => {
    inputRef.current.click();
  };
  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name.toLowerCase();
      if (fileName.endsWith(".csv") || fileName.endsWith(".xlsx")) {
        onChange(file);
      } else {
        // Display an error message or toast indicating unsupported file format
        console.error(
          "Unsupported file format. Please upload a CSV or Excel file."
        );
        const title = "Error";
        let detail = "Please upload an Excel file to proceed";
        const type = "error";
        notify(title, detail, type);
        // Reset the input field
        inputRef.current.value = null;
      }
    } else {
      onChange(null);
      inputRef.current.value = null;
    }
  };
  return (
    <div>
      <input
        type="file"
        ref={inputRef}
        onChange={handleChange}
        style={{ display: "none" }}
      />
      <button className="primary-button" onClick={handleClick}>
        Upload Excel
      </button>
    </div>
  );
}

export default ExcelUploadButton;
